import React from "react";
import { useLingui } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

export default function CommentInput({
  text,
  setText,
  createComment,
}: {
  text: string;
  setText: (text: string) => void;
  createComment: () => void;
}) {
  const { t } = useLingui();
  return (
    <textarea
      className="w-full min-h-[80px] max-h-[300px] p-3 border border-border rounded-lg resize-none focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2"
      value={text}
      autoFocus={true}
      placeholder={t(msg`Write here`)}
      onChange={(e) => setText(e.target.value)}
      onKeyDown={(e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
          e.preventDefault();
          createComment();
        }
      }}
    />
  );
}
